module.exports = __webpack_public_path__ + "static/media/thermoready-4.da1b74a6.png";